export const GET_EXISTING_TRAN_SUMMARY_LIST_LOADING =
  'GET_EXISTING_TRAN_SUMMARY_LIST_LOADING';
export const GET_EXISTING_TRAN_SUMMARY_LIST_DATE_DATA =
  'GET_EXISTING_TRAN_SUMMARY_LIST_DATE_DATA';
export const GET_EXISTING_TRAN_SUMMARY_LIST_LOADING_ERROR =
  'GET_EXISTING_TRAN_SUMMARY_LIST_LOADING_ERROR';
export const GET_TRAN_SUMMARY_BEGIN_END_DATE_LOADING =
  'GET_TRAN_SUMMARY_BEGIN_END_DATE_LOADING';
export const SET_TRAN_SUMMARY_BEGIN_END_DATE =
  'SET_TRAN_SUMMARY_BEGIN_END_DATE';
export const GET_TRAN_SUMMARY_BEGIN_END_DATE_LOADING_ERROR =
  'GET_TRAN_SUMMARY_BEGIN_END_DATE_LOADING_ERROR';
export const CLEAR_TRANSACTION_SUMMARY_ERROR =
  'CLEAR_TRANSACTION_SUMMARY_ERROR';
export const GET_EXISTING_TRAN_SUMMARY_PRINT_LOADING =
  'GET_EXISTING_TRAN_SUMMARY_PRINT_LOADING';
export const GET_EXISTING_TRAN_SUMMARY_PRINT_LOADING_ERROR =
  'GET_EXISTING_TRAN_SUMMARY_PRINT_LOADING_ERROR';
export const SET_TO_DATE_MIN = 'SET_TO_DATE_MIN';
export const SET_FROM_DATE_MAX = 'SET_FROM_DATE_MAX';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/state/TransactionSummaryList/types.js